module.exports = __webpack_public_path__ + "static/media/tds-black-logo.d21280df.png";